// EventsCard.tsx — "Today's events" rail card (Sprint 83, ADR-082).
// Port of the prototype's EventsCard (home_sf.jsx).
import React from 'react';
import { CalendarOutlined } from '@ant-design/icons';
import { RailCard } from './RailCard';

export type EventTone = 'red' | 'amber' | 'blue' | 'green' | 'violet';

export interface EventItem {
  /** Time, e.g. "10:00". */
  t: string;
  /** AM/PM. */
  ap: string;
  /** Title. */
  h: React.ReactNode;
  /** Sub-line. */
  s: React.ReactNode;
  tone?: EventTone;
}

const TONE: Record<EventTone, string> = {
  red: 'var(--red)',
  amber: 'var(--amber)',
  blue: 'var(--blue)',
  green: 'var(--ok)',
  violet: 'var(--violet)',
};

export interface EventsCardProps {
  items: EventItem[];
  title?: string;
}

export const EventsCard: React.FC<EventsCardProps> = ({ items, title = "Today's events" }) => (
  <RailCard icon={<CalendarOutlined />} tone="var(--blue)" title={title}>
    {items.length === 0 && <div className="rempty">No events scheduled.</div>}
    {items.map((e, i) => (
      <div className="evt-item" key={i}>
        <div className="et">
          <div className="t num">{e.t}</div>
          <div className="ap">{e.ap}</div>
        </div>
        <div className="ebar" style={{ background: TONE[e.tone ?? 'blue'] }} />
        <div className="eb">
          <div className="h">{e.h}</div>
          <div className="s">{e.s}</div>
        </div>
      </div>
    ))}
  </RailCard>
);

export default EventsCard;
